// scroll bar
import 'simplebar/src/simplebar.css';

import ReactDOM from 'react-dom';

import { Provider } from "react-redux";
import store from '../src/redux/store';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

//
import { UseWalletProvider } from 'use-wallet';

import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { ApolloClient, ApolloProvider, InMemoryCache } from "@apollo/client";

// ----------------------------------------------------------------------

const client = new ApolloClient({
  uri: "https://api.thegraph.com/subgraphs/name/shahzeb8285/nftyardcolletoral",
  cache: new InMemoryCache(),
  fetchOptions: {
    mode: 'no-cors',
  },
})

ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}>
      <UseWalletProvider
        chainId={137}
        connectors={{
          // This is how connectors get configured
        }}
      >
        <BrowserRouter>
          <ApolloProvider client={client}>
            <App />
          </ApolloProvider>
        </BrowserRouter>
      </UseWalletProvider>
    </Provider>
  </HelmetProvider>,
  document.getElementById('root')
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
